/**
 * Initialization tracker for logging purposes
 */

import { useEffect } from "react";

interface ITrackerStep {
  name: string;
  startTime: number;
  endTime?: number;
  error?: string;
}

class TrackerManager {
  private reportedSteps: Map<string, ITrackerStep> = new Map();
  private rendersCount: number = 0;

  startStep(stepName: string) {
    if (process.env['NODE_ENV'] !== 'development') return;
    if (!this.reportedSteps.has(stepName)) {
      const step: ITrackerStep = {
        name: stepName,
        startTime: Date.now(),
      }
      this.reportedSteps.set(stepName, step);
    }
  }

  completeStep(stepName: string, error?: string) {
    if (process.env['NODE_ENV'] !== 'development') return;
    const stepData = this.reportedSteps.get(stepName);
    if (stepData) {
      stepData.endTime = Date.now();
      if (error) stepData.error = error;
    }
  }

  reportTracker(_from: string) {
    if (process.env['NODE_ENV'] !== 'development') return;
    if (this.reportedSteps.size === 0) return;
    this.rendersCount += 1;
    this.clearTracker();
  };

  clearTracker() {
    this.reportedSteps.clear();
  }
}

// Singleton instance
export const trackerManager = new TrackerManager();


interface ITrackerManagerHook {
  (from: string, dependencies: unknown[]): void;
}

export const useTrackerManagerHook: ITrackerManagerHook = (from: string, dependencies = []): void => {
  useEffect(() => {
    trackerManager.reportTracker(from);
  }, dependencies);
}
